











import Vue from 'vue'
import FilterDropdown from '@/pages/common/filter-dropdown/FilterDropdown.vue'
import {
  coursesDropdownModel,
  loadCourses,
  setSelectedCourse,
  $courses,
} from '@/pages/common/dropdowns/courses/courses-name-dropdown/courses-dropdown.model'
import { DropdownItem } from '@/pages/common/types'

export default Vue.extend({
  components: {
    FilterDropdown,
  },
  effector: {
    ...coursesDropdownModel.store,
    $courses,
  },
  methods: {
    ...coursesDropdownModel.methods,
    onSelectItem(item: DropdownItem | null) {
      setSelectedCourse(item || null)
      this.$emit('setItem', item ? item.name : null)
    },
  },
  mounted() {
    loadCourses()
  },
})
